<template>
  <div class="category-popup-wrapper">
    <el-button
      class="dialog"
      type="text"
      icon="icon-arrow-b"
      @click="outerVisible = true"
    >
      {{ filterPath }}
    </el-button>
    <div
      v-if="outerVisible"
      class="category-dropdown-wrapper"
    >
      <span
        class="back"
        @click="outerVisible = false"
      />
      <div
        v-for="categoryItem in categories"
        :key="categoryItem.id"
        class="category-wrapper"
      >
        <div
          class="categories"
          @click="selectCategory(categoryItem)"
        >
          <i
            class="category-icon"
            :class="'icon-'+categoryItem.key"
          />
          <div class="content">
            <span class="name">{{ $t('category.' + categoryItem.key) }}</span>
            <span class="badge">{{ categoryCount(categoryItem) }} {{ $t('filter.static.ads-badge.label') }}</span>
          </div>
          <div class="arrow">
            <i class="icon-arrow-b" />
          </div>
        </div>
        <template v-if="categoryItem.id === category.id">
          <template v-if="subcategory && !subcategory.id && categoryItem.subcategories.length">
            <template v-for="subcategoryItem in categoryItem.subcategories">
              <div
                :key="subcategoryItem.id"
                class="subcategory"
                :class="{make:subcategoryItem.id === subcategory.id}"
                @click="selectSubcategory(subcategoryItem)"
              >
                <i
                  class="subcategory-icon"
                  :class="['icon-'+subcategoryItem.key]"
                />
                <span>{{ $t('subcategory.' + categoryItem.key + '.' + subcategoryItem.key) }}</span>
                <div
                  :class="{ hide: subcategoryItem.id === subcategory.id }"
                  class="arrow"
                >
                  <i class="icon-arrow-r" />
                </div>
              </div>
              <!--<div v-if="subcategory.inner === true">-->
              <!--<div class="make-model" v-for="make in subcategory.makes" :key="make.name" @click="makeInner(make)">-->
              <!--<div>-->
              <!--<span>{{make.name }}</span>-->
              <!--<div v-if="!make.inner" class="arrow">-->
              <!--<i class="icon-arrow-r"></i>-->
              <!--</div>-->
              <!--</div>-->
              <!--<div class="models" v-if="make.inner" >-->
              <!--<div class="model" v-for="model in make.models" :key="model">-->
              <!--<span>{{model}}</span>-->
              <!--<div class="arrow">-->
              <!--<i class="icon-arrow-r"></i>-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
            </template>
          </template>
          <template v-else>
            <dynamic-fields-mobile
              :subcategory="subcategory"
              :category="category"
              @reached-end="outerVisible = false"
            />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import isArray from 'lodash-es/isArray';
  import { getAttributeTypes } from '@/store/filters/filters.getters';
  import DynamicFieldsMobile from '../MainLeftFilters/LeftFilter/DynamicFieldsMobile';

  export default {
    components: { DynamicFieldsMobile },
    data() {
      return {
        outerVisible: false,
      };
    },
    computed: {
      ...mapState({
        categories: state => state.temp.categories.list,
        category: state => state.filters.category || {},
        subcategory: state => state.filters.subcategory || { name: '' },
      }),
      filterPath() {
        const items = [];

        if (this.category && this.category.id) {
          items.push(this.$t(`category.${this.category.key}`));
        }

        if (this.subcategory && this.subcategory.id) {
          items.push(this.$t(`subcategory.${this.category.key}.${this.subcategory.key}`));
        }

        return items.length ? items.join(' > ') : '';
      },
    },
    watch: {
      outerVisible(val) {
        this.$emit('openChange', val);
      },
    },
    methods: {
      selectCategory(category) {
        this.$store.dispatch('setCategory', category);

        // Close if nothing is visible next
        if (!getAttributeTypes({ category, subcategory: this.subcategory }).length) {
          this.outerVisible = false;
        }
      },
      selectSubcategory(subcategory) {
        this.$store.dispatch('setSubcategory', subcategory);

        // Close if nothing is visible next
        if (!getAttributeTypes({ category: this.category, subcategory }).length) {
          this.outerVisible = false;
        }
        // this.outerVisible = false;
      },
      categoryCount(categoryItem) {
        return categoryItem.active_ads_count +
          (isArray(categoryItem.subcategories) ?
            categoryItem.subcategories.reduce((acc, item) => acc + item.active_ads_count, 0) : 0
          );
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/MobileDialog.vue